import { useState } from 'react';
import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import { CoursesViewAllCourses } from 'components/courses';

import type { HomeModuleProps } from './Home';

const HomeCoursesCategory = ({
  defaultTitle,
  limit,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module || !module.categories?.length) return null;

  const queryParams = `&categoryId=${module.categories.join(
    filterValuesSeparator
  )}`;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <CoursesViewAllCourses
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit || limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        queryParams={queryParams}
        showAllLinkHref={'/courses?type=all' + queryParams}
        title={title}
        titleShowCount={false}
      />
    </div>
  );
};

export default HomeCoursesCategory;
